import { render, staticRenderFns } from "./TabEncomienda.vue?vue&type=template&id=33a09bcc&scoped=true&"
import script from "./TabEncomienda.vue?vue&type=script&lang=ts&"
export * from "./TabEncomienda.vue?vue&type=script&lang=ts&"
import style0 from "./TabEncomienda.vue?vue&type=style&index=0&id=33a09bcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a09bcc",
  null
  
)

export default component.exports